export const pricingKeys = {
  all: ['pricing'] as const,
  featureLimits: () => [...pricingKeys.all, 'feature-limits'] as const,
  featureLimit: (userId: string, featureKey: string, itemId?: string, increment?: number) =>
    [...pricingKeys.featureLimits(), { userId, featureKey, itemId, increment }] as const,
  plans: () => [...pricingKeys.all, 'plans'] as const,
  availablePlans: () => [...pricingKeys.plans(), 'available'] as const,
  userPlans: (userId: string) => [...pricingKeys.plans(), 'user', userId] as const,
  userPlanFeatures: (userId: string) => [...pricingKeys.userPlans(userId), 'features'] as const,
  subscriptions: () => [...pricingKeys.all, 'subscriptions'] as const,
  userSubscription: (userId: string) => [...pricingKeys.subscriptions(), 'user', userId] as const,
  invoices: () => [...pricingKeys.all, 'invoices'] as const,
  userInvoices: (userId: string) => [...pricingKeys.invoices(), 'user', userId] as const,
  completePricingInfo: (userId: string) => [...pricingKeys.all, 'complete', userId] as const,
  pendingProof: (userId: string) => [...pricingKeys.all, 'pending', userId] as const,
}
